import React, { useMemo } from 'react'

import cl from 'classnames'
import { makeStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    width: '100%',
    paddingTop: ({ paddingTop }) => paddingTop /* 16:9 Aspect Ratio */,
  },
  media: {
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
}))

const ImageContainer = ({ src, ratio, classes, className, children, ...rest }) => {
  className ||= classes.root
  const padding = useMemo(() => {
    return {
      paddingTop: `${(100 / ratio).toFixed(2)}%`,
    }
  }, [ratio])
  const ownClasses = useStyles(padding)

  return (
    <div className={cl(ownClasses.container, className)}>
      <Image className={ownClasses.media} src={src} {...rest} />
      {children}
    </div>
  )
}

export default ImageContainer
